import { useI18n } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';
import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { copyToClipboard } from '#src/app/shared/utils/clipboard';

import { getVisibleUrl } from './utils/getVisibleUrl';

type Params = {
	url: string;
	shortUrl?: string;
};

type Data = {
	resolvedUrl: string;
	visibleUrl: string;
	title: string;
	buttonLabel: string;
	toastSuccessLabel: string;
	toastErrorLabel: string;
	ariaLabel: string;
};

type Actions = {
	onCopyClick: () => Promise<boolean>;
};

export function useInlineShareCopyCard({ url, shortUrl }: Params): ModelHookResult<Data, Actions> {
	const { translate } = useI18n();
	const track = useTracking();
	const { i18n } = useUtilityContext();
	const resolvedUrl = shortUrl ?? url;

	return {
		data: {
			resolvedUrl,
			visibleUrl: getVisibleUrl(resolvedUrl),
			// TODO: Add translation if productized
			title: 'Copy your unique share link',
			buttonLabel: translate('fe.components.psf.share.buttons.copy_link'),
			toastSuccessLabel: translate('fe.components.share_buttons.copied'),
			toastErrorLabel: translate(
				'corgi.petition_actions.supporter_voice_video.record.unsupported_browser.copy_button.error',
			),
			ariaLabel: translate('fe.components.psf.share.buttons.copy_link'),
		},
		actions: {
			onCopyClick: async () => {
				const isCopied = await copyToClipboard(resolvedUrl, i18n);

				if (isCopied) {
					void track('combo_psf_share_copy_click');
				}

				return isCopied;
			},
		},
	};
}
